import styled from 'styled-components';

// ========================================
// Links Grid
// ========================================

export const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  justify-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

// ========================================
// Link Cards
// ========================================

export const LinkCard = styled.a`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 100%;
  text-decoration: none;
  color: inherit;
  position: relative;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    border-color: rgba(30, 76, 92, 0.3);
  }

  @media (max-width: 768px) {
    max-width: 300px;
  }
  
  @media (max-width: 480px) {
    flex-direction: row;
    max-width: 100%;
  }
`;

export const LinkImageContainer = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  ${LinkCard}:hover & img {
    transform: scale(1.05);
  }
  
  @media (max-width: 768px) {
    height: 150px;
  }
  
  @media (max-width: 480px) {
    width: 100px;
    min-width: 100px;
    height: 100%;
    align-self: stretch;
  }
`;

export const LinkImage = styled.img``;

export const ExternalLinkBadge = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 10;
  
  svg {
    color: #1E4C5C;
    font-size: 1.3rem;
  }
  
  ${LinkCard}:hover & {
    background: #1E4C5C;
    transform: scale(1.1);
    
    svg {
      color: white;
    }
  }
  
  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    top: 0.5rem;
    right: 0.5rem;
    
    svg {
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
    width: 26px;
    height: 26px;
    top: 0.5rem;
    right: 0.5rem;
    
    svg {
      font-size: 0.8rem;
    }
  }
`;

export const LinkContent = styled.div`
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    padding: 0.75rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.65rem 0.75rem 0.65rem 0.65rem;
    padding-right: 2.5rem;
    justify-content: center;
  }
`;

export const LinkTitle = styled.h3`
  font-size: 1.4rem;
  color: #1E4C5C;
  margin-bottom: 1rem;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 0.35rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
    margin-bottom: 0.25rem;
  }
`;

export const LinkDescription = styled.p`
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    line-height: 1.35;
  }
  
  @media (max-width: 480px) {
    font-size: 0.75rem;
    line-height: 1.3;
  }
`;

